import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { AlertComponent } from '@core/ui';
import { MaintenanceBannerViewModel } from '@mp/system/maintenance/domain';

@Component({
  selector: 'mps-maintenance-banner',
  templateUrl: './maintenance-banner.component.html',
  styleUrl: './maintenance-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, AlertComponent],
})
export class MaintenanceBannerComponent {
  /**
   * The content of the banner. Ob überhaupt eines zu zeigen ist, entscheidet der Container.
   */
  readonly viewModel: InputSignal<MaintenanceBannerViewModel> = input.required<MaintenanceBannerViewModel>();
}
